import { createEffect, createSignal, onCleanup, onMount } from "solid-js";

type DecodedJwt = {
  userId: number;
  email: string;
  userType: "user" | "admin";
  firstName: string;
  lastName: string;
  connectionCode: string;
  signedWaiver: boolean;
  phone: string | null;
  verified: boolean;
};

const keyBase = `com.roadrally/keys/1.0.0`;

export const authorizationSignal = createSignal<string | undefined>(undefined);
const [authorization, setAuthorization] = authorizationSignal;

onMount(() => {
  const token = localStorage.getItem(`${keyBase}/token`);
  if (token) setAuthorization(token);
});

export const resetToken = (token: string) =>
  setAuthorization(token ? token : undefined);

createEffect(() => {
  const auth = authorization();
  if (auth) localStorage.setItem(`${keyBase}/token`, auth);
  else localStorage.removeItem(`${keyBase}/token`);
});

export const getUser = (): DecodedJwt | undefined => {
  const token = authorization();
  if (!token) return undefined;
  console.log(parseJwt(token));
  return parseJwt(token) as DecodedJwt;
};

export const createSignInWithRedirectEffect = (message: string) => {
  const [auth] = authorizationSignal;
  const loggedIn = () => auth() && getUser();
  const timeout = setTimeout(() => {
    if (!loggedIn()) {
      window.location.href = `/login/?${new URLSearchParams({
        redirect: encodeURIComponent(window.location.href),
        message: encodeURIComponent(message),
      })}`;
    }
  }, 100);
  onCleanup(() => {
    clearTimeout(timeout);
  });
};

export const logout = () => {
  setAuthorization(undefined);
  window.location.href = "/";
};

const parseJwt = (token: string) =>
  JSON.parse(
    b64DecodeUnicode(token.split(".")[1].replace("-", "+").replace("_", "/"))
  );

const b64DecodeUnicode = (str: string) =>
  decodeURIComponent(
    Array.prototype.map
      .call(
        atob(str),
        (c: string) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      )
      .join("")
  );
